export default __webpack_public_path__ + "static/media/dep2_7.c171ffd8.png";